// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import {
  StyledTitleModal,
  StyledSubTitleModal,
  StyledButtonsWrapper,
  StyledCancelButton,
  StyledConfirmButton,
} from './DeleteOrderModalStyles';

interface DeleteOrderModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteOrderModal = ({ isOpen, isLoading, onClose, onConfirm }: DeleteOrderModalProps) => {
  const { t } = useTranslation(['orders']);

  return (
    <Modal visible={isOpen} onCancel={onClose} size={ModalSize.LARGE}>
      <StyledTitleModal>{t('delete_order_modal_title')}</StyledTitleModal>
      <StyledSubTitleModal>{t('delete_order_modal_sub_title')}</StyledSubTitleModal>
      <StyledButtonsWrapper>
        <StyledCancelButton onClick={onClose} disabled={isLoading}>
          {t('delete_order_modal_cancel')}
        </StyledCancelButton>
        <StyledConfirmButton onClick={onConfirm} disabled={isLoading} type="text">
          {t('delete_order_modal_confirm')}
        </StyledConfirmButton>
      </StyledButtonsWrapper>
    </Modal>
  );
};

export default DeleteOrderModal;
